import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyDYOvlh66EbuBLXjHCfWAR0KUyxRdp0CiE",
    authDomain: "saigelogin.firebaseapp.com",
    projectId: "saigelogin",
    storageBucket: "saigelogin.firebasestorage.app",
    messagingSenderId: "1060559931860",
    appId: "1:1060559931860:web:92ea8ad4837f4e6a086e41",
    measurementId: "G-QC16GZ6TQ2"
  };
  

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
